var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 6.84118,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5195_42694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3516 11.5193C16.3516 8.82723 17.0899 7.36274 21.1666 6.66537C23.9343 6.1911 27.483 6.13182 30.7932 6.66537C33.4077 7.08727 35.6082 8.99125 35.6082 11.5193V20.4009C35.6082 23.0058 33.4718 25.1396 30.7932 25.1396H21.1666C17.8995 25.1396 15.1459 27.8631 15.1459 30.9421V35.2034H11.8359C9.03606 35.2034 7.40593 33.2297 6.72113 30.4678C5.79742 26.7575 5.83663 24.5468 6.72113 20.9934C7.48799 17.8934 9.93835 16.2578 12.7384 16.2578H25.9816V15.0721H16.3514V11.5191L16.3516 11.5193Z",
    fill: "url(#paint0_linear_5195_42694)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6082 39.9419C35.6082 42.634 33.2185 43.9975 30.7932 44.6775C27.1444 45.7027 24.216 45.5458 21.1666 44.6775C18.6198 43.9522 16.3516 42.4702 16.3516 39.9419V31.0603C16.3516 28.5042 18.5309 26.3216 21.1666 26.3216H30.7932C33.9997 26.3216 36.8139 23.6123 36.8139 20.4005V16.2578H40.4234C43.2269 16.2578 44.5468 18.2942 45.2385 20.9934C46.2014 24.7421 46.2442 27.5456 45.2385 30.4678C44.2648 33.3063 43.2233 35.2034 40.4234 35.2034H25.9816V36.3891H35.6082V39.9419Z",
    fill: "url(#paint1_linear_5195_42694)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7598 10.9308C18.7598 9.94753 19.5658 9.15234 20.5647 9.15234C21.5598 9.15234 22.3697 9.94733 22.3697 10.9308C22.3697 11.911 21.56 12.7058 20.5647 12.7058C19.5662 12.7058 18.7598 11.9108 18.7598 10.9308ZM29.5916 40.5326C29.5916 39.5525 30.4013 38.7577 31.3966 38.7577C32.3951 38.7577 33.2016 39.5527 33.2016 40.5326C33.2016 41.5159 32.3955 42.3111 31.3966 42.3111C30.4016 42.3111 29.5916 41.5161 29.5916 40.5326Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 6.84118,
    stroke: "#FFCD40"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5195_42694",
    x1: 35.6084,
    y1: 17.5283,
    x2: 6.04329,
    y2: 17.2878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#366A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3679B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5195_42694",
    x1: 45.9766,
    y1: 30.8233,
    x2: -12.5483,
    y2: 30.8233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5195_42694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/Python.7b1385422cdcad2449c9ed3f3bac36d7.svg";
export { ForwardRef as ReactComponent };